import { memo } from "react";
import styles from "./VersionInfo.module.scss";

const VersionInfo = memo(() => {
    return <div className={styles.container}>version Beta-14.09.26-1</div>;
});

export default VersionInfo;
